import React from "react";
import Image from "@/bit/components/components.c-image";
import Text from "@/bit/components/components.text";
import PropTypes from "prop-types";
import CustomLink from "@/bit/components/components.custom-link";

const comprobarComponentVariation = (link) => {
  const { taggingInfo } = link;
  if (taggingInfo && taggingInfo.componentVariation) {
    return taggingInfo.componentVariation;
  }
  return "all";
};

const Slide = ({
  hash = "",
  img,
  title,
  link,
  taggingInfo,
  index,
  cmsHandler,
  alias,
  listIndex,
  blockName,
  frontalListToDelete,
  CmsEditableGroupIcons,
}) => {
  const finalTaggingInfo = taggingInfo && {
    ...taggingInfo,
    componentContent: title?.text,
    componentVariation: comprobarComponentVariation(link),
    eventType: "click",
  };

  const getSlideContent = () => {
    return (
      <>
        {/* Bolitas de edicion aqui */}
        {CmsEditableGroupIcons && (
          <CmsEditableGroupIcons
            elementProps={{}}
            deleteProps={{
              index,
              itemIdDotNotation: `${blockName}.cms-component-product-thumbs.${listIndex}.cms-ml-product-thumbs-1`,
              alias,
              frontalListToDelete,
            }}
            visibleTools={{
              hiring: false,
              edit: false,
              deleteItem: true,
            }}
            cmsHandler={cmsHandler}
          />
        )}
        {img && (
          <div className="img-container" aria-hidden="true">
            <Image
              {...img}
              cmsHandler={cmsHandler}
              hash={hash}
              compressionByResize={false}
              objectFit="contain"
              cydata="FeaturedSection Carousel Image"
            />
          </div>
        )}
        {((title && title.text) || cmsHandler) && (
          <Text
            {...title}
            cmsHandler={cmsHandler}
            className="product-text"
            cydata="FeaturedSection Carousel Title"
          />
        )}
      </>
    );
  };

  return (
    <>
      <div className="carousel-slide product-thumb">
        {(link && link.href) || cmsHandler ? (
          <CustomLink
            {...link}
            taggingInfo={finalTaggingInfo}
            cydata="FeaturedSection Carousel CustomLink"
            className="product-slide-link"
            cmsHandler={cmsHandler}
          >
            {getSlideContent()}
          </CustomLink>
        ) : (
          <>{getSlideContent()}</>
        )}
      </div>
      <style jsx>{`.carousel-slide {
  width: 11.43rem;
  height: 9.4375rem;
  background-color: white;
  border: solid #eeeeee 1px;
  border-radius: 16px;
  position: relative;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  :global(.text) {
    line-height: 1.5rem;
  }

  :global(.product-slide-link) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  :global(.img-container) {
    width: 80%;
    height: 50%;
    display:block;
    margin: 0 auto;
    position: relative;

    :global(.device-image) {
      height: 100%;
      object-fit: contain;
      margin: 0 auto;
    }
  }
  :global(.product-text) {
    margin-top: 1.5rem;
  }
}

// Tablet
@media screen and (min-width: 768px) {
  :global(.carousel-item-wrapper) {
    overflow: visible;
  }

  .carousel-slide {
    &:hover {
      border: solid rgb(221, 221, 221) 1px;
    }
  }
}
`}</style>
    </>
  );
};

export default Slide;

Slide.propTypes = {
  src: PropTypes.object,
  text: PropTypes.object,
};
